'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var extend = require('../util/extend');
var Ajax = require('../xhr');
var Logger = require('../util/logger');
var Url = require('../util/url');
var NAME = 'metric';

var MetricManager = function () {
    function MetricManager(cfgManager) {
        _classCallCheck(this, MetricManager);

        this.cfgManager = cfgManager;
        this.tags = {};
        this.kvs = {};
        this.extraData = '';
    }
    /**
     * 设置维度信息
     * 
     * @param {Object} tags - key为维度名称，value为维度数据
     * @memberof MetricManager
     */


    _createClass(MetricManager, [{
        key: 'setTags',
        value: function setTags(tags) {
            this.tags = extend(this.tags, tags);
        }
    }, {
        key: 'getTags',
        value: function getTags(tagName) {
            return tagName ? this.tags[tagName] : this.tags;
        }
        /**
         * 增加metric数据
         * 
         * @param {string} name - metric名称 
         * @param {number} value  - metric值
         * @memberof MetricManager
         */

    }, {
        key: 'setMetric',
        value: function setMetric(name, value) {
            var _this = this;

            if (typeof name !== 'string') {
                return Logger.log('metric名称必须是string类型');
            }
            if (typeof value !== 'number') {
                return Logger.log('metric\u503C\u5FC5\u987B\u662Fnumber\u7C7B\u578B,\u5F53\u524D\u4E3A' + name + '-' + value);
            }

            if (!this.kvs[name]) {
                this.kvs[name] = [];
            }
            this.kvs[name].push(value);

            try {
                if (this.cfgManager.get(NAME).combo) {
                    if (this.timeout) {
                        clearTimeout(this.timeout);
                        this.timeout = null;
                    }

                    this.timeout = setTimeout(function () {
                        _this.report();
                    }, this.cfgManager.get(NAME).delay || 1500);
                }
            } catch (e) {}
        }
    }, {
        key: 'setExtraData',
        value: function setExtraData(msg) {
            this.extraData = msg || '';
        }
    }, {
        key: 'getMetric',
        value: function getMetric(name) {
            return name ? this.kvs[name] : this.kvs;
        }
    }, {
        key: 'clearMetric',
        value: function clearMetric() {
            this.kvs = {};
        }
    }, {
        key: '_rollbackMetric',
        value: function _rollbackMetric(preMetric) {
            if (preMetric) {
                for (var name in preMetric) {
                    if (preMetric.hasOwnProperty(name)) {
                        this.kvs[name] = preMetric[name].concat(this.kvs[name] || []);
                    }
                }
            }
        }
    }, {
        key: 'report',
        value: function report() {
            var _this2 = this;

            if (!this.kvs || Object.keys(this.kvs).length === 0) return;

            var data = {
                kvs: this.kvs,
                tags: this.tags,
                ts: parseInt(+new Date() / 1000),
                extraData: this.extraData
            };
            var preMetric = this.kvs;
            this.clearMetric();

            var cfgManager = this.cfgManager;
            var url = Url.stringify(cfgManager.getApiPath(NAME), {
                p: cfgManager.get('project'),
                pageId: cfgManager.get('pageId'),
                unionId: cfgManager.getExtension('unionId')
            });

            Ajax({
                url: url,
                type: 'POST',
                header: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: 'data=' + encodeURIComponent(JSON.stringify(data)),
                fail: function fail() {
                    _this2._rollbackMetric(preMetric);
                }
            });
        }
    }]);

    return MetricManager;
}();

module.exports = MetricManager;